/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */
import { getPayload } from 'Services/Logger/utils/datadog';

class DatadogAdapter {
  static origin = 'Aurora-FrontEnd:';

  debug(id, message, optionalInfo) {
    this._log('debug', message, id, optionalInfo);
  }

  info(id, message, optionalInfo) {
    this._log('info', message, id, optionalInfo);
  }

  warn(id, message, optionalInfo) {
    this._log('warn', message, id, optionalInfo);
  }

  error(id, message, optionalInfo) {
    this._log('error', message, id, optionalInfo);
  }

  _log(level, message, id, optionalInfo) {
    const payload = getPayload(optionalInfo, id);
    if (window.DD_LOGS?.logger?.[level]) {
      window.DD_LOGS.logger[level](
        `${DatadogAdapter.origin} ${message}, ${payload.applicationProcessId}`,
        payload,
        level,
      );
    }
  }
}

const singletonInstance = new DatadogAdapter();

export default Object.freeze(singletonInstance);
